var SocialLatestQuestions = {
  init: function() {
    this.setVariables();
    this.retrieveQuestions();
  },
  setVariables: function() {
    this.$latestQuestionsList = $("#latestQuestionsList");
    this.$noLatestQuestions = $("#noLatestQuestions");
  },
  retrieveQuestions: function() {
    var _self = this;

    $.get(Config.contextPath + "/controller/socialsearch/latest/")
      .done(function(r) {

        var count = r.results.length;
        if (count <= 0) {
          _self.$noLatestQuestions.removeClass("hide");
          _self.$latestQuestionsList.addClass("hide");
          return;
        }

        $.each(r.results, function(i, question) {
          var $li = $("<li></li>");
          var $href = $("<a></a>");
          $href.attr("href", Config.contextPath + "/controller/view/discussion/" + question.discussion.id);
          $href.html(question.discussion.title);
          $li.append($href);
          _self.$latestQuestionsList.append($li);
        });
      });
  }
};